import React, { useState } from "react";
import "react-pro-sidebar/dist/css/styles.css";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SidebarHeader,
  SidebarContent,
  SidebarFooter,
  SubMenu,
} from "react-pro-sidebar";
// 👇 FIX: Import FontAwesomeIcon component
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; 
// ... (Your FontAwesome imports)
import {
  faUser,
  faSignOutAlt,
  faChartBar,
  faHandHoldingUsd,
  faTachometerAlt,
  faEnvelope,
  faCogs,
  faChevronLeft,
  faChevronRight,
  faBuilding,
  faIdCard,
  faDollarSign,
  faHome,
  faVideo,
  faCamera,
  faMoneyCheck,
  faUserTie,
  faUserSecret,
  faCog,
  faPiggyBank,
  faEye,
  faFileAlt,
  faBell,
  faMoneyBillWave,
  faKey,
  faUsers,
  faTools,
  faTrash,
  faClipboardList,
  faFileInvoiceDollar,
  faWater,
  faPlusCircle,
  faSearch,
  faEdit,
  faTrashAlt,
  faBalanceScale,
  faCoins,
  faPercentage,
  faArrowRightToBracket,
  faArrowRightFromBracket,
  faUniversity,
  faWallet,
  faLink,
  faSyncAlt,
  faReceipt,
  faBars 
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { AuthGuard } from "../App";
import { EmailGuard } from "../App";

const Home = () => {
  const navigate = useNavigate();
  // State for desktop sidebar collapse (narrowed view)
  const [collapsed, setCollapsed] = useState(false); 
  // State for mobile sidebar toggle (show/hide menu on small screen)
  const [toggled, setToggled] = useState(false); 
  const userDataString = localStorage.getItem("user");
  const userData = JSON.parse(userDataString);
  const userEmail = userData.email;

  // --- (All your unchanged handleXXXClick functions remain here) ---
  const handleProfileClick = () => {
    navigate("/admin/profile");
  };

  const handleLogoutClick = () => {
    navigate("/logout");
  };
  // ... (All other handle functions) ...
  const handleUserBalancesClick = () => {
    handleNavigationWithEmailCheck("/admin/userbalances");
  };

  const handleOwnerBalancesClick = () => {
    handleNavigationWithEmailCheck("/admin/ownerbalances");
  };

  const handleReservationsClick = () => {
    handleNavigationWithEmailCheck("/admin/reservations");
  };

  const handleBillClick = () => {
    handleNavigationWithEmailCheck("/admin/bill");
  };

  const handleWaterBillClick = () => {
    handleNavigationWithEmailCheck("/admin/waterbill");
  };

  const handleCommissionsClick = () => {
    handleNavigationWithEmailCheck("/admin/commissions");
  };

  const handleVacatingClick = () => {
    handleNavigationWithEmailCheck("/admin/vacating");
  };

  const handleVideosClick = () => {
    handleNavigationWithEmailCheck("/admin/videos");
  };

  const handlePhotosClick = () => {
    handleNavigationWithEmailCheck("/admin/photos");
  };

  const handlePromocodesClick = () => {
    handleNavigationWithEmailCheck("/admin/promocodes");
  };

  const handleAllUsersClick = () => {
    handleNavigationWithEmailCheck("/admin/users");
  };

  const handleBank = () => {
    handleNavigationWithEmailCheck("/admin/bank");
  };

  const handlePropertiesClick = () => {
    handleNavigationWithEmailCheck("/admin/propertypage");
  };

  const handleRentalsClick = () => {
    handleNavigationWithEmailCheck("/admin/rentals");
  };

  const handleMoneyOutClick = () => {
    handleNavigationWithEmailCheck("/admin/moneyout");
  };

  const handleMoneyInClick = () => {
    handleNavigationWithEmailCheck("/admin/moneyin");
  };

  const handleDepositClick = () => {
    handleNavigationWithEmailCheck("/admin/deposit");
  };

  const handleMonthlyFeesClick = () => {
    handleNavigationWithEmailCheck("/admin/monthlyfees");
  };

  const handlePropertyKYCClick = () => {
    handleNavigationWithEmailCheck("/admin/propertykyc");
  };

  const handlePropertyHunter = () => {
    handleNavigationWithEmailCheck("/admin/propertyhunter");
  };

  const handleViewSettlementUser = () => {
    handleNavigationWithEmailCheck("/admin/viewusersettlement");
  };

  const handleViewSettlementLandlord = () => {
    handleNavigationWithEmailCheck("/admin/viewlandlordsettlement");
  };

  const handleViewSettlementHunter = () => {
    handleNavigationWithEmailCheck("/admin/viewpropertyhuntersettlement");
  };
  const handleViewDepositSettlements = () => {
    handleNavigationWithEmailCheck("/admin/admincompletesettlements");
  };

  const handleViewNotifications = () => {
    handleNavigationWithEmailCheck("/admin/viewnotifications");
  };
  const handleRecordsView = () => {
    handleNavigationWithEmailCheck("/admin/recordsview");
  };
  const handleViewAuditLogs = () => {
    handleNavigationWithEmailCheck("/admin/auditlogs");
  };
  const handleAgencyViewingFee = () => {
    handleNavigationWithEmailCheck("/admin/agencyviewing");
  };
  const handleMaintenaceRequests = () => {
    handleNavigationWithEmailCheck("/admin/maintenancerequest");
  };
  const handleWithdrawals = () => {
    handleNavigationWithEmailCheck("/admin/withdrawals");
  };
  const handleVerifyCodes = () => {
    handleNavigationWithEmailCheck("/admin/viewverifycodes");
  };
  const handleAdminSettlementsView = () => {
    handleNavigationWithEmailCheck("/admin/viewadminsettlements");
  };
  const handleServiceCharge = () => {
    handleNavigationWithEmailCheck("/admin/serviceratecharge");
  };
  const handleWithdrawalRateCharge = () => {
    handleNavigationWithEmailCheck("/admin/withdrawalratecharge");
  };
  const handleWithdrawalLink = () => {
    handleNavigationWithEmailCheck("/admin/withdrawalshelplandlord");
  };

  const handleAddReservationBills = () => {
    handleNavigationWithEmailCheck("/admin/addreservationbills");
  };

  const handleCheckWaterUnits = () => {
    handleNavigationWithEmailCheck("/admin/checkwaterunits");
  };

  const handleUpdateLandlordBalances = () => {
    handleNavigationWithEmailCheck("/admin/updatelandlordbalance");
  };
  const handleUpdateUserBalances = () => {
    handleNavigationWithEmailCheck("/admin/updateuserbalances");
  };

  const handleUpdateBills = () => {
    handleNavigationWithEmailCheck("/admin/updatebills");
  };

  const handleEmailSending = () => {
    handleNavigationWithEmailCheck("/admin/emailsender");
  };

  const handlePropertyTransactions = () => {
    handleNavigationWithEmailCheck("/admin/transactionsviewpage");
  };

  const handleTrashUnitsPrice = () => {
    handleNavigationWithEmailCheck("/admin/checktrashprice");
  };

  const handleOfflinePayments = () => {
    handleNavigationWithEmailCheck("/admin/viewofflinepayments");
  };

  const handleOfflinePropertyPayments = () => {
    handleNavigationWithEmailCheck("/admin/viewofflinepropertypayments");
  };

  const handleAllTrashUnitsPrice = () => {
    handleNavigationWithEmailCheck("/admin/alltrashunitsprice");
  };

  const handleViewTrashBills = () => {
    handleNavigationWithEmailCheck("/admin/viewtrashbills");
  };
  const handleManualReservationsClick = () => {
    handleNavigationWithEmailCheck("/admin/manualreservations");
  };

  const handleSMSSending = () => {
    handleNavigationWithEmailCheck("/admin/smssender");
  };

  const handleAddManualSettlement = () => {
    handleNavigationWithEmailCheck("/admin/addmanualsettlement");
  };
  const handlePropertyWaterBillClick = () => {
    handleNavigationWithEmailCheck("/admin/propertywaterbill");
  };
  const handlePropertyTrashBill = () => {
    handleNavigationWithEmailCheck("/admin/propertytrashbill");
  };

  const handleRentMpesaTopUps = () => {
    handleNavigationWithEmailCheck("/admin/rentmpesatopupsstatus");
  };

  const handleTenantMpesaTopUps = () => {
    handleNavigationWithEmailCheck("/admin/tenantmpesatopups");
  };
  const handleSMSSettings = () => {
    handleNavigationWithEmailCheck("/admin/smsintroduction");
  };

  const handleMpesaSettings = () => {
    handleNavigationWithEmailCheck("/admin/mpesaintroduction");
  };

  const handleCardPaymentSettings = () => {
    handleNavigationWithEmailCheck("/admin/cardpaymentsettings");
  };

  const handleMultipleRegistrations = () => {
    handleNavigationWithEmailCheck("/admin/manualregistrationusers");
  };

  const handleIPBlocking = () => {
    handleNavigationWithEmailCheck("/admin/blockip");
  };

  const handleLandlordMpesaTopUps = () => {
    handleNavigationWithEmailCheck("/admin/landlordmpesatopups");
  };
  const handlePendingBills = () => {
    handleNavigationWithEmailCheck("/admin/pendingbills");
  };

  const handleRateLimit = () => {
    handleNavigationWithEmailCheck("/admin/ratelimit");
  };

  const handleMonthlyStatementForm = () => {
    handleNavigationWithEmailCheck("/admin/monthlystatementform");
  };

  const handleNavigationWithEmailCheck = (targetRoute) => {
    if (userEmail === "xavierkioko12@gmail.com") {
      navigate(targetRoute);
    } else {
      alert("You are not authorized to navigate to this page.");
    }
  };
  
  // Function to close sidebar on small screens after a click
  const handleMenuItemClick = (route) => {
    handleNavigationWithEmailCheck(route);
    // Close the sidebar on mobile after selecting a menu item
    if (toggled) {
      setToggled(false);
    }
  };

  return (
    <EmailGuard>
      <AuthGuard>
        {/* Full-screen container for the dashboard layout */}
        <div className="flex min-h-screen bg-gray-100">
          
          {/* ------------------------------------------------------------- */}
          {/* 1. MOBILE/SMALL SCREEN MENU BUTTON (FIXED AND ALWAYS VISIBLE) */}
          {/* ------------------------------------------------------------- */}
          {/* This button appears ONLY when the menu is closed (!toggled) and ONLY on small screens (lg:hidden) */}
          {!toggled && (
              <div className="fixed top-4 left-4 z-50 lg:hidden">
                  <button
                      onClick={() => setToggled(true)} // Set toggled to TRUE to open the menu
                      className="p-3 rounded-md bg-gray-800 text-white shadow-lg hover:bg-gray-700 transition duration-200"
                      title="Open Menu"
                  >
                      <FontAwesomeIcon icon={faBars} size="lg" />
                  </button>
              </div>
          )}

          {/* ------------------------------------------------------------- */}
          {/* 2. PRO SIDEBAR COMPONENT (USES COLLAPSED & TOGGLED PROPS) */}
          {/* ------------------------------------------------------------- */}
          <div className="relative z-40 shadow-xl">
            <ProSidebar 
                collapsed={collapsed} 
                toggled={toggled} 
                onToggle={setToggled} 
                breakPoint="lg" 
                style={{ height: "100vh" }}
            >
              <SidebarHeader>
                <div className="flex justify-between items-center p-4 h-16 bg-gray-800 border-b border-gray-700">
                  <h2
                    className={`text-xl font-extrabold text-white transition-opacity duration-300 ${
                      collapsed ? "opacity-0" : "opacity-100" // Hide text when collapsed
                    }`}
                  >
                    Admin Panel
                  </h2>
                  
                  {/* COLLAPSE BUTTON (ONLY FOR DESKTOP, HIDDEN ON MOBILE) */}
                  <button
                    onClick={() => setCollapsed(!collapsed)}
                    // Use hidden lg:block to ensure this button only shows on large screens
                    className={`text-white hover:text-blue-400 transition-colors duration-200 p-2 rounded-full hover:bg-gray-700 hidden lg:block ${
                      collapsed ? "ml-auto" : "" // Push to the right when collapsed is true
                    }`}
                    title={collapsed ? "Expand Sidebar" : "Collapse Sidebar"}
                  >
                    {collapsed ? (
                      <FontAwesomeIcon icon={faChevronRight} size="lg" />
                    ) : (
                      <FontAwesomeIcon icon={faChevronLeft} size="lg" />
                    )}
                  </button>
                </div>
              </SidebarHeader>

              {/* Sidebar Content: Added scroll for many menu items */}
              <SidebarContent className="overflow-y-auto flex-1 bg-gray-900">
                <Menu iconShape="circle">
                  {/* General */}
                  <MenuItem
                    icon={<FontAwesomeIcon icon={faUser} />}
                    onClick={() => handleMenuItemClick("/admin/profile")}
                    className="hover:bg-gray-700 transition-colors duration-150"
                  >
                    Profile
                  </MenuItem>

                  {/* Finances SubMenu */}
                  <SubMenu
                    title="Finances"
                    icon={<FontAwesomeIcon icon={faChartBar} />}
                    className="hover:bg-gray-700 transition-colors duration-150"
                  >
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faBalanceScale} />}
                      onClick={() => handleMenuItemClick("/admin/userbalances")}
                    >
                      User Balances
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faCoins} />}
                      onClick={() => handleMenuItemClick("/admin/ownerbalances")}
                    >
                      Owner Balances
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faPercentage} />}
                      onClick={() => handleMenuItemClick("/admin/promocodes")}
                    >
                      Promocodes
                    </MenuItem>

                    <MenuItem
                      icon={<FontAwesomeIcon icon={faDollarSign} />}
                      onClick={() => handleMenuItemClick("/admin/commissions")}
                    >
                      Commissions
                    </MenuItem>

                    <MenuItem
                      icon={<FontAwesomeIcon icon={faArrowRightFromBracket} />}
                      onClick={() => handleMenuItemClick("/admin/moneyout")}
                    >
                      MoneyOut
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faArrowRightToBracket} />}
                      onClick={() => handleMenuItemClick("/admin/moneyin")}
                    >
                      MoneyIn
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faDollarSign} />}
                      onClick={() => handleMenuItemClick("/admin/monthlyfees")}
                    >
                      MonthlyFees
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faUniversity} />}
                      onClick={() => handleMenuItemClick("/admin/bank")}
                    >
                      Bank
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faWallet} />}
                      onClick={() => handleMenuItemClick("/admin/withdrawals")}
                    >
                      Withdrawals
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faLink} />}
                      onClick={() => handleMenuItemClick("/admin/withdrawalshelplandlord")}
                    >
                      Withdrawal Link Landlord
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faSyncAlt} />}
                      onClick={() => handleMenuItemClick("/admin/updatelandlordbalance")}
                    >
                      UpdateLandlordBalances
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faSyncAlt} />}
                      onClick={() => handleMenuItemClick("/admin/updateuserbalances")}
                    >
                      UpdateUserBalances
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faReceipt} />}
                      onClick={() => handleMenuItemClick("/admin/viewofflinepayments")}
                    >
                      OfflinePayments
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faReceipt} />}
                      onClick={() => handleMenuItemClick("/admin/viewofflinepropertypayments")}
                    >
                      OfflinePropertyPayments
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faHome} />}
                      onClick={() => handleMenuItemClick("/admin/transactionsviewpage")}
                    >
                      PropertyTransactions
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faUserTie} />}
                      onClick={() => handleMenuItemClick("/admin/propertyhunter")}
                    >
                      PropertyHunter
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faUserTie} />}
                      onClick={() => handleMenuItemClick("/admin/addmanualsettlement")}
                    >
                      Add Manual Settlement
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faUserTie} />}
                      onClick={() => handleMenuItemClick("/admin/monthlystatementform")}
                    >
                      MonthlyStatementForm
                    </MenuItem>
                  </SubMenu>

                  {/* Management SubMenu */}
                  <SubMenu
                    title="Management"
                    icon={<FontAwesomeIcon icon={faClipboardList} />}
                    className="hover:bg-gray-700 transition-colors duration-150"
                  >
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faClipboardList} />}
                      onClick={() => handleMenuItemClick("/admin/reservations")}
                    >
                      Reservations
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faClipboardList} />}
                      onClick={() => handleMenuItemClick("/admin/manualreservations")}
                    >
                      Manual Reservations
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faFileInvoiceDollar} />}
                      onClick={() => handleMenuItemClick("/admin/bill")}
                    >
                      Bill
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faWater} />}
                      onClick={() => handleMenuItemClick("/admin/waterbill")}
                    >
                      WaterBill
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faWater} />}
                      onClick={() => handleMenuItemClick("/admin/propertywaterbill")}
                    >
                      PropertyWaterBill
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faTrash} />}
                      onClick={() => handleMenuItemClick("/admin/propertytrashbill")}
                    >
                      PropertyTrashBills
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faPlusCircle} />}
                      onClick={() => handleMenuItemClick("/admin/addreservationbills")}
                    >
                      AddBills
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faSearch} />}
                      onClick={() => handleMenuItemClick("/admin/checkwaterunits")}
                    >
                      CheckWaterUnits
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faEdit} />}
                      onClick={() => handleMenuItemClick("/admin/updatebills")}
                    >
                      UpdateBills
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faTrashAlt} />}
                      onClick={() => handleMenuItemClick("/admin/checktrashprice")}
                    >
                      TrashUnitsPrice
                    </MenuItem>
                  </SubMenu>

                  {/* Views SubMenu */}
                  <SubMenu
                    title="Views"
                    icon={<FontAwesomeIcon icon={faEye} />}
                    className="hover:bg-gray-700 transition-colors duration-150"
                  >
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faFileAlt} />}
                      onClick={() => handleMenuItemClick("/admin/auditlogs")}
                    >
                      ViewAuditLogs
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faFileAlt} />}
                      onClick={() => handleMenuItemClick("/admin/recordsview")}
                    >
                      View Records
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faBell} />}
                      onClick={() => handleMenuItemClick("/admin/viewnotifications")}
                    >
                      ViewNotifications
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faMoneyBillWave} />}
                      onClick={() => handleMenuItemClick("/admin/agencyviewing")}
                    >
                      ViewAgencyViewingFee
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faPiggyBank} />}
                      onClick={() => handleMenuItemClick("/admin/admincompletesettlements")}
                    >
                      ViewDepositSettlements
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faKey} />}
                      onClick={() => handleMenuItemClick("/admin/viewverifycodes")}
                    >
                      VerifyCodes
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faUsers} />}
                      onClick={() => handleMenuItemClick("/admin/users")}
                    >
                      ViewUsers
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faTools} />}
                      onClick={() => handleMenuItemClick("/admin/maintenancerequest")}
                    >
                      MaintenaceRequests
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faTrash} />}
                      onClick={() => handleMenuItemClick("/admin/viewtrashbills")}
                    >
                      ViewTrashBills
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faDollarSign} />}
                      onClick={() => handleMenuItemClick("/admin/alltrashunitsprice")}
                    >
                      AllTrashUnitsPrice
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faDollarSign} />}
                      onClick={() => handleMenuItemClick("/admin/landlordmpesatopups")}
                    >
                      LandlordMpesaTopUps
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faDollarSign} />}
                      onClick={() => handleMenuItemClick("/admin/tenantmpesatopups")}
                    >
                      TenantMpesaTopUps
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faDollarSign} />}
                      onClick={() => handleMenuItemClick("/admin/rentmpesatopupsstatus")}
                    >
                      RentMpesaTopUps
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faDollarSign} />}
                      onClick={() => handleMenuItemClick("/admin/pendingbills")}
                    >
                      Pending Bills
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faDollarSign} />}
                      onClick={() => handleMenuItemClick("/admin/ratelimit")}
                    >
                      Rate Limit
                    </MenuItem>
                  </SubMenu>

                  {/* Settlements SubMenu */}
                  <SubMenu
                    title="Settlements"
                    icon={<FontAwesomeIcon icon={faMoneyCheck} />}
                    className="hover:bg-gray-700 transition-colors duration-150"
                  >
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faUser} />}
                      onClick={() => handleMenuItemClick("/admin/viewusersettlement")}
                    >
                      ViewSettlementUser
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faUserTie} />}
                      onClick={() => handleMenuItemClick("/admin/viewlandlordsettlement")}
                    >
                      ViewSettlementLandlord
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faUserSecret} />}
                      onClick={() => handleMenuItemClick("/admin/viewpropertyhuntersettlement")}
                    >
                      ViewSettlementHunter
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faCog} />}
                      onClick={() => handleMenuItemClick("/admin/viewadminsettlements")}
                    >
                      AdminSettlementsView
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faSignOutAlt} />}
                      onClick={() => handleMenuItemClick("/admin/vacating")}
                    >
                      Vacating
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faPiggyBank} />}
                      onClick={() => handleMenuItemClick("/admin/deposit")}
                    >
                      Deposit
                    </MenuItem>
                  </SubMenu>

                  {/* Properties SubMenu */}
                  <SubMenu
                    title="Properties"
                    icon={<FontAwesomeIcon icon={faBuilding} />}
                    className="hover:bg-gray-700 transition-colors duration-150"
                  >
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faBuilding} />}
                      onClick={() => handleMenuItemClick("/admin/propertypage")}
                    >
                      Properties
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faIdCard} />}
                      onClick={() => handleMenuItemClick("/admin/propertykyc")}
                    >
                      PropertyKYC
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faDollarSign} />}
                      onClick={() => handleMenuItemClick("/admin/serviceratecharge")}
                    >
                      ServiceCharge
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faDollarSign} />}
                      onClick={() => handleMenuItemClick("/admin/withdrawalratecharge")}
                    >
                      Withdrawal Rates Landlord
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faHome} />}
                      onClick={() => handleMenuItemClick("/admin/rentals")}
                    >
                      Rentals
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faVideo} />}
                      onClick={() => handleMenuItemClick("/admin/videos")}
                    >
                      Videos
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faCamera} />}
                      onClick={() => handleMenuItemClick("/admin/photos")}
                    >
                      Photos
                    </MenuItem>
                  </SubMenu>

                  {/* Communication SubMenu */}
                  <SubMenu
                    title="Communication"
                    icon={<FontAwesomeIcon icon={faEnvelope} />}
                    className="hover:bg-gray-700 transition-colors duration-150"
                  >
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faEnvelope} />}
                      onClick={() => handleMenuItemClick("/admin/emailsender")}
                    >
                      Send Email
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faEnvelope} />}
                      onClick={() => handleMenuItemClick("/admin/smssender")}
                    >
                      Send SMS
                    </MenuItem>
                  </SubMenu>

                  {/*SETTINGS SubMenu */}
                  <SubMenu
                    title="Settings"
                    icon={<FontAwesomeIcon icon={faCog} />}
                    className="hover:bg-gray-700 transition-colors duration-150"
                  >
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faCog} />}
                      onClick={() => handleMenuItemClick("/admin/smsintroduction")}
                    >
                      Sms Settings
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faCog} />}
                      onClick={() => handleMenuItemClick("/admin/mpesaintroduction")}
                    >
                      Mpesa Settings
                    </MenuItem>
                    <MenuItem
                      icon={<FontAwesomeIcon icon={faCog} />}
                      onClick={() => handleMenuItemClick("/admin/blockip")}
                    >
                      IP Blocking
                    </MenuItem>
                     <MenuItem
                      icon={<FontAwesomeIcon icon={faCog} />}
                      onClick={() => handleMenuItemClick("/admin/manualregistrationusers")}
                    >
                      Multiple Registrations
                    </MenuItem>

                    <MenuItem
                      icon={<FontAwesomeIcon icon={faCog} />}
                      onClick={() => handleMenuItemClick("/admin/cardpaymentsettings")}
                    >
                      Card Payment Settings
                    </MenuItem>
                  </SubMenu>

                  {/* Logout */}
                  <MenuItem
                    icon={<FontAwesomeIcon icon={faSignOutAlt} />}
                    onClick={handleLogoutClick}
                    className="hover:bg-red-700 transition-colors duration-150"
                  >
                    Logout
                  </MenuItem>
                </Menu>
              </SidebarContent>

              {/* Sidebar Footer: Clearer visual boundary */}
              <SidebarFooter>
                <div className="text-gray-400 text-center p-4 border-t border-gray-700 bg-gray-800">
                  <p className="text-xs">© 2024 Reivax Softwares</p>
                  <p className="text-xs">All Rights Reserved</p>
                </div>
              </SidebarFooter>
            </ProSidebar>
          </div>

          {/* ------------------------------------------------------------- */}
          {/* 3. MAIN CONTENT AREA */}
          {/* ------------------------------------------------------------- */}
          <main className="flex-1 p-8 overflow-y-auto transition-all duration-300">
            
            {/* Auxiliary button for expanding the sidebar on LARGE screens (when it's collapsed) */}
            {collapsed && !toggled && (
              <button
                onClick={() => setCollapsed(false)}
                // Fixed position relative to the main content's start, visible only on large screens
                className="absolute top-4 left-4 z-30 text-gray-800 hover:text-blue-600 transition-colors duration-200 p-2 rounded-full hover:bg-gray-200 hidden lg:block"
                title="Expand Sidebar"
              >
                <FontAwesomeIcon icon={faChevronRight} size="lg" />
              </button>
            )}

            <h1 className="text-3xl font-bold text-gray-900 mb-8 mt-12 lg:mt-0">
              Welcome, Admin Kioko! 👋
            </h1>

            {/* Quick Stats Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
              <Card
                title="Total Users"
                value="2,450"
                icon={faUsers}
                color="blue"
              />
              <Card
                title="Pending Approvals"
                value="12"
                icon={faClipboardList}
                color="yellow"
              />
              <Card
                title="Revenue (MoM)"
                value="KES 15,800"
                icon={faDollarSign}
                color="green"
              />
              <Card
                title="Maintenance Requests"
                value="5"
                icon={faTools}
                color="red"
              />
            </div>

            {/* Quick Actions Section */}
            <section className="mt-8 bg-white p-6 rounded-xl shadow-lg border border-gray-200">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4 border-b pb-2">
                Quick Navigation
              </h2>
              <div className="flex flex-wrap gap-4">
                <Button onClick={() => handleMenuItemClick("/admin/users")}>
                  <FontAwesomeIcon icon={faUsers} className="mr-2" /> Manage
                  Users
                </Button>
                <Button onClick={() => handleMenuItemClick("/admin/reservations")}>
                  <FontAwesomeIcon icon={faClipboardList} className="mr-2" />
                  View Reservations
                </Button>
                <Button onClick={() => handleMenuItemClick("/admin/propertypage")}>
                  <FontAwesomeIcon icon={faBuilding} className="mr-2" /> View
                  Properties
                </Button>
                <Button onClick={() => handleMenuItemClick("/admin/emailsender")}>
                  <FontAwesomeIcon icon={faEnvelope} className="mr-2" /> Send
                  Email
                </Button>
              </div>
            </section>
          </main>
        </div>
      </AuthGuard>
    </EmailGuard>
  );
};

// --- Helper Components ---

const Button = ({ children, onClick }) => (
  <button
    onClick={onClick}
    className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg transition duration-300 ease-in-out focus:outline-none focus:ring-4 focus:ring-blue-300 shadow-md"
  >
    {children}
  </button>
);

const Card = ({ title, value, icon, color }) => {
  const colorClasses = {
    blue: "bg-blue-500",
    green: "bg-green-500",
    yellow: "bg-yellow-500",
    red: "bg-red-500",
  };
  const textClasses = {
    blue: "text-blue-600",
    green: "text-green-600",
    yellow: "text-yellow-600",
    red: "text-red-600",
  };
  const iconBgClasses = {
    blue: "bg-blue-100",
    green: "bg-green-100",
    yellow: "bg-yellow-100",
    red: "bg-red-100",
  };

  return (
    <div className="bg-white p-6 rounded-xl shadow-lg border-l-4 border-blue-500 hover:shadow-xl transition duration-300">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-sm font-medium text-gray-500 uppercase tracking-wider">
            {title}
          </h2>
          <p className={`text-3xl font-extrabold ${textClasses[color]} mt-1`}>
            {value}
          </p>
        </div>
        <div className={`p-3 rounded-full ${iconBgClasses[color]} ${textClasses[color]}`}>
          <FontAwesomeIcon icon={icon} size="lg" />
        </div>
      </div>
    </div>
  );
};



export default Home;